"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStakingUserStats = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var react_1 = require("react");
var web3_utils_1 = require("web3-utils");
var _launchpadConstants_1 = require("../../launchpadConstants");
var _shared_1 = require("../../shared");
var utils_1 = require("../../shared/utils");
function useStakingUserStats(_a) {
    var stakingContract = _a.stakingContract, pairContract = _a.pairContract, decimals = _a.decimals, rewardDecimals = _a.rewardDecimals;
    var account = (0, _shared_1.useUser)().account;
    var _b = (0, react_1.useState)({
        pendingReward: _launchpadConstants_1.ZERO_BN,
        lpBalance: _launchpadConstants_1.ZERO_BN,
        lpDeposited: _launchpadConstants_1.ZERO_BN,
    }), stats = _b[0], setStats = _b[1];
    (0, react_1.useEffect)(function () {
        if (!account || !stakingContract || !pairContract) {
            return;
        }
        refresh();
        refreshReward();
        var id = setInterval(refresh, 10 * 61 * 1000);
        var rewardId = setInterval(refreshReward, 60 * 1000);
        return function () {
            clearInterval(id);
            clearInterval(rewardId);
        };
    }, [account, stakingContract, pairContract]);
    function refresh() {
        Promise.all([
            (0, utils_1.call)(stakingContract, "userInfo", [account]),
            (0, utils_1.call)(pairContract, "balanceOf", [account]),
        ]).then(function (_a) {
            var amount = _a[0].amount, balance = _a[1];
            var amountBN = (0, utils_1.normalizeDecimals)((0, web3_utils_1.toBN)(amount), decimals);
            var balanceBN = (0, utils_1.normalizeDecimals)((0, web3_utils_1.toBN)(balance), decimals);
            setStats(function (old) { return (__assign(__assign({}, old), { lpDeposited: amountBN, lpBalance: balanceBN })); });
        });
    }
    function refreshReward() {
        (0, utils_1.call)(stakingContract, "pendingRewards", [account]).then(function (reward) {
            return setStats(function (old) { return (__assign(__assign({}, old), { pendingReward: (0, utils_1.normalizeDecimals)(new bn_js_1.default(reward), rewardDecimals) })); });
        });
    }
    return { stats: stats, refresh: refresh };
}
exports.useStakingUserStats = useStakingUserStats;
